import React, { useEffect, useState } from "react";
import { SkillhouseWrapper } from "./components/SkillhouseWrapper";
import { SynopsisObject } from "./components/menu/menuContent/data.types";
import { PhoneSlide } from "./contexts/phone/Phone.types";
import { MenuProvider } from "./contexts/menu/menu.provider";
import { VideoSettingsProvider } from "./contexts/videoSettings/videoSettings.provider";
import { PhoneProvider } from "./contexts/phone/phone.provider";
import { PrefersReducedMotionProvider } from "./contexts/prefersReducedMotion/prefersReducedMotion.provider";

function App() {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch("/data.json")
      .then((res) => res.json())
      .then(setData)
      .catch((err) => console.error("Error loading JSON:", err));
  }, []);

  if (!data) {
    return null;
  }

  return (
    <VideoSettingsProvider>
      <PrefersReducedMotionProvider>
        <MenuProvider>
          <PhoneProvider>
            <SkillhouseWrapper
              phoneSlides={data.slides as Array<PhoneSlide>}
              synopsis={data.synopsis as SynopsisObject}
              buyTicketsLink={data.buyTicketsLink as string}
              trailerLink={data.trailerLink as string}
            />
          </PhoneProvider>
        </MenuProvider>
      </PrefersReducedMotionProvider>
    </VideoSettingsProvider>
  );
}

export default App;
